import "core-js/modules/es.string.trim.js";
import i18n from 'i18next';
/**
 * Return an error when a field does not pass its field requirements
 *
 * Currently only handles the `required` property.
 */

export default function defaultGetError(value, field) {
  if (field.required) {
    var isEmptyArray = Array.isArray(value) && value.length === 0;
    var isEmptyString = typeof value === 'string' && !(value !== null && value !== void 0 && value.trim().length);
    var isFalse = value === false;
    if (isEmptyArray || isEmptyString || isFalse) {
      return i18n.t('error_required_field');
    }
  }
  return undefined;
}